import Cookie from "cookie"

let domain = ""

function extractTopLevelDomain(hostname) {
  if (hostname.includes("rta-os")) return hostname
  try {
    let subdomain = ""
    const topDomain = [
      "com",
      "net",
      "org",
      "edu",
      "gov",
      "info",
      "biz",
      "name",
      "aero",
      "info",
      "mil",
      "pro",
      "cn",
      "hk",
      "tw"
    ]
    const domain = hostname
    // 若为 IP 地址、localhost，则直接返回
    const ipAddressReg =
      /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
    if (ipAddressReg.test(domain) || domain.includes("localhost")) {
      return domain.replace(/:\d+/, "")
    }
    const domainList = domain.split(".")
    let index = domainList.length - 1
    topDomain.forEach(item => {
      if (domain.includes(item)) {
        const i = domainList.findIndex(d => d == item)
        if (i != -1 && i <= index) {
          index = i
        }
      }
    })
    const len = index - 1 < 0 ? 0 : index - 1
    subdomain = domainList.slice(len).join(".")
    return subdomain || ""
  } catch (e) {
    return ""
  }
}

export function getTopLevelDomain(req) {
  if (process.server) {
    const fullUrl = req.headers["x-forwarded-host"] || req.headers.host
    return extractTopLevelDomain(fullUrl)
  } else {
    const fullUrl = window.location.hostname
    return extractTopLevelDomain(fullUrl)
  }
}

export const cookieUniversal = ({ req, res, store, parseJSON = true }) => {
  const isClient = typeof document === "object" && typeof document.cookie === "string"
  const isServer = typeof req === "object" && typeof res === "object" && typeof module !== "undefined"
  const isNeither = (!isClient && !isServer) || (isClient && isServer)

  const getHeaders = fromRes => {
    if (isServer) {
      let h = req.headers.cookie || ""
      if (fromRes) {
        h = res.getHeaders()
        h = h["set-cookie"] ? h["set-cookie"].map(c => c.split(";")[0]).join(";") : ""
      }
      return h
    }
    if (isClient) return document.cookie || ""
  }

  const getResponseCookies = () => {
    let cookies = res.getHeader("Set-Cookie")
    cookies = typeof cookies === "string" ? [cookies] : cookies
    return cookies || []
  }
  const setResponseCookie = cookieList => res.setHeader("Set-Cookie", cookieList)

  const parseToJSON = (val, enableParsing) => {
    if (!enableParsing) return val
    try {
      return JSON.parse(val)
    } catch (err) {
      return val
    }
  }

  // public api
  const state = {
    parseJSON,

    set(name = "", value = "", opts = {}) {
      if (isNeither) return
      value = typeof value === "object" ? JSON.stringify(value) : value
      opts = Object.assign({ domain, path: "/", secure: true, httpOnly: true }, opts)
      if (isServer) {
        const cookies = getResponseCookies()
        cookies.push(Cookie.serialize(name, value, opts))
        // fix 解决服务端设置cookie值，无法即时获取问题
        store.commit("setResCookies", {
          ...store.state.resCookies,
          [name]: value
        })
        setResponseCookie(cookies)
      } else {
        store.commit("setResCookies", {})
        document.cookie = Cookie.serialize(name, value, opts)
      }
    },

    setAll(cookieList = []) {
      if (isNeither) return
      if (!Array.isArray(cookieList)) return
      cookieList.forEach(cookie => {
        const { name = "", value = "" } = cookie
        let { opts = {} } = cookie
        opts = Object.assign({ domain, path: "/", secure: true, httpOnly: true }, opts)
        state.set(name, value, opts)
      })
    },

    get(name = "", opts = { fromRes: false, parseJSON: state.parseJSON }) {
      if (isNeither) return ""
      const cookies = Cookie.parse(getHeaders(opts.fromRes))
      const cookie = cookies[name]
      return parseToJSON(cookie, opts.parseJSON)
    },

    getAll(opts = { fromRes: false, parseJSON: state.parseJSON }) {
      if (isNeither) return {}
      const cookies = Cookie.parse(getHeaders(opts.fromRes))
      for (const cookie in cookies) {
        cookies[cookie] = parseToJSON(cookies[cookie], opts.parseJSON)
      }
      return cookies
    },

    remove(name = "", opts = {}) {
      if (isNeither) return
      opts.expires = new Date(0)
      opts = Object.assign({ domain, path: "/", secure: true }, opts)
      state.set(name, "", opts)
    },

    removeAll(opts = { path: "/" }) {
      if (isNeither) return
      const cookies = Cookie.parse(getHeaders())
      opts = Object.assign({ domain, path: "/", secure: true }, opts)
      for (const cookie in cookies) {
        state.remove(cookie, opts)
      }
    },

    // expose cookie library
    nodeCookie: Cookie
  }

  return state
}

export default ({ req, res, store }, inject) => {
  domain = getTopLevelDomain(req)
  inject("cookies", cookieUniversal({ req, res, store }))
}
